import { Result } from '@cplug/frontend-core/utils'
import { FeatureFlagsResponseDTO, type FeatureFlagItem } from './DTOs/FeatureFlagDTO'
import CPBaseGateway from '~/shared/gateways/CPBaseGateway'

export class CPFeatureFlagGateway extends CPBaseGateway {
  async getAll (): Promise<Result<FeatureFlagItem[]>> {
    const response = await this.get<{ feature_flags: FeatureFlagItem[] }>('feature-flags')

    return this.parseResponse(
      response,
      FeatureFlagsResponseDTO,
      dto => Result.ofValue(dto.data.feature_flags)
    )
  }
}
